import React from "react";
import { Route, Switch } from "react-router-dom";
import { PageTypesDashboard } from "../model/PageTypesDashboard";
import { PageGroupsLibrary } from "../pagetypes/PageGroupsLibrary";
import { IngestionPage } from "../ingestor/IngestionPage";
import { DriversLicenseInsurance } from "../dl_insurance/DriversLicenseInsurance";
import { Manifest } from "../common/Manifest";
import { OrgDetail } from "../org/OrgDetail";
import { OrgEdit } from "../org/OrgEdit";
import { OrgCreate } from "../org/OrgCreate";
import { DocTypeList } from "../doctypes/DocTypeList";
import { DocTypeCreate } from "../doctypes/DocTypeCreate";
import { DocTypeEdit } from "../doctypes/DocTypeEdit";
import { DocTypeUsers } from "../doctypes/DocTypeUsers";
import { SearchPage } from "../search/SearchPage";
import { PrivateRoute } from "./PrivateRoute";
import { OrgContact } from "../common/OrgContact";
import { OrgUsers } from "../org/OrgUsers";
import { connect } from "react-redux";
import { ViewAllPages2 } from "components/search/ViewAllPages2";
import { AirtableReconciliationReport } from "components/ops/AirtableReconciliationReport";

function OrgLayout(props) {
  return (
    <Switch>

      <PrivateRoute
        exact path="/org/:id/users"
        component={OrgUsers}
      />

      <PrivateRoute
        exact path="/org/:id/doctypes"
        component={DocTypeList}
      />

      <PrivateRoute
        exact path="/org/:id/doctypes/add"
        component={DocTypeCreate}
      />

      <PrivateRoute
        exact path="/org/:id/doctypes/:doc_type_name"
        component={DocTypeEdit}
      />

      <PrivateRoute
        exact path="/org/:id/dl_insurance"
        component={DriversLicenseInsurance}
      />

      <PrivateRoute
        exact path="/org/:id/dealjackets"
        component={SearchPage}
      />

      <PrivateRoute
        path="/org/:org_id/dealjacket/:jacket_id/:view_type"
        component={ViewAllPages2}
      />

      <PrivateRoute
        exact path="/org/:id/ingestion"
        component={IngestionPage}
      />

      <PrivateRoute
        exact path="/org/:id/pagetypes"
        component={PageTypesDashboard}
      />

      <PrivateRoute
        exact path="/org/:id/pagetypes/groups"
        component={PageGroupsLibrary}
      />

      <PrivateRoute
        exact path="/org/:id/manifest"
        component={Manifest}
      />

      <PrivateRoute
        exact path="/org/:id/contact"
        component={OrgContact}
      />

      <PrivateRoute
        exact path="/org/:id/reports/airtable"
        component={AirtableReconciliationReport}
      />

      <PrivateRoute
        path="/org/:id/edit"
        component={OrgEdit}
      />

      <PrivateRoute
        exact path="/org/add"
        component={OrgCreate}
      />

      <PrivateRoute
        exact path="/org/:id"
        component={OrgDetail}
      />

      <PrivateRoute
        exact path="/org/:id/doctype/:doctype/users"
        component={DocTypeUsers}
      />

    </Switch>
  );
}

function mapStateToProps(state) {
  const { authentication } = state;
  return {
    authentication,
  };
}

const connectedOrgLayout = connect(mapStateToProps)(OrgLayout);
export { connectedOrgLayout as OrgLayout };
